import { render, staticRenderFns } from "./FormulationManufacturingAndFinancialTab.vue?vue&type=template&id=83011ab2&scoped=true&"
import script from "./FormulationManufacturingAndFinancialTab.vue?vue&type=script&lang=js&"
export * from "./FormulationManufacturingAndFinancialTab.vue?vue&type=script&lang=js&"
import style0 from "./FormulationManufacturingAndFinancialTab.vue?vue&type=style&index=0&id=83011ab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83011ab2",
  null
  
)

export default component.exports